import { Link } from '@solidjs/meta';

export function OpenSans()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap' rel='stylesheet' />
	</>);
}

OpenSans.fontFamily = '"Open Sans", sans-serif';
